window.addEventListener('error', function(e) {
  if (e.message && e.message.includes('Cannot set properties of null')) {
    e.preventDefault();
    return false;
  }
});

if (!window.cartDrawerDecimalInitialized) {
  window.cartDrawerDecimalInitialized = true;

  let isDrawerOpen = false;
  let isUpdating = false;
  let hasDrawerContentInitialized = false;
  let hasDrawerRecommendationsInitialized = false;
  let lastUpdateErrorInfo = null;

  function getCartKeyToProductMap() {
    try {
      const raw = localStorage.getItem('cart_key_to_product');
      return raw ? JSON.parse(raw) : {};
    } catch (_e) {
      return {};
    }
  }

  function saveCartKeyToProductMap(map) {
    try {
      localStorage.setItem('cart_key_to_product', JSON.stringify(map || {}));
    } catch (_e) {}
  }

  function persistCartKeyProductMapFromDOM() {
    try {
      const map = getCartKeyToProductMap();
      document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal[data-key][data-product-id]').forEach(el => {
        const key = el.getAttribute('data-key');
        const pid = (el.getAttribute('data-product-id') || '').toString().replace(/[^0-9]/g, '');
        if (key && pid) {
          map[key] = pid;
          
          const removeButtons = el.querySelectorAll('.remove-item');
          removeButtons.forEach(btn => {
            if (btn.dataset.key !== key) {
              btn.dataset.key = key;
              btn.setAttribute('data-key', key);
            }
          });
        }
      });
      saveCartKeyToProductMap(map);
    } catch (_e) {}
  }

  function getProductIdForKey(key) {
    const node = document.querySelector(`#cart-drawer-decimal .cart-item-decimal[data-key="${CSS.escape(key)}"]`);
    const fromDom = node?.getAttribute('data-product-id');
    if (fromDom && fromDom !== 'null') return fromDom.toString().replace(/[^0-9]/g, '');
    const map = getCartKeyToProductMap();
    if (map && map[key]) return map[key].toString().replace(/[^0-9]/g, '');
    return null;
  }

  function extractProductIdFromKey(key) {
    const mapped = getProductIdForKey(key);
    if (mapped) { return mapped; }

    const possibleIds = [key, key?.split(':')?.[0], key?.split('_')?.[0]].filter(Boolean);
    for (const id of possibleIds) {
      const cleanId = id.toString().replace(/[^0-9]/g, '');
      if (getProductDataFromStorage(cleanId) || getAvailableQuantityFromStorage(cleanId)) { return cleanId; }
      }
    const genericData = localStorage.getItem('unidentified_product');
    if (genericData) {
      return 'generic';
    }
    return null;
  }


  function getProductDataFromStorage(productId) {
    try {
      if (!productId || productId === 'null' || productId === null) {
        const data = localStorage.getItem('unidentified_product');
        if (data) {
          try {
            const productData = JSON.parse(data);
            return productData;
          } catch (parseError) {
          }
        }
      }
      
      const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
      
      const storageKeys = [
        `product_data_${cleanProductId}`,
        `product_data_${productId}`,
        'unidentified_product'
      ];
      
      for (const key of storageKeys) {
        const data = localStorage.getItem(key);
        if (data) {
          try {
            const productData = JSON.parse(data);
            return productData;
          } catch (parseError) {
          }
        }
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  function getAvailableQuantityFromStorage(productId) {
    try {
      if (!productId || productId === 'null' || productId === null) {
        const productData = getProductDataFromStorage(null);
        if (productData && productData.availableQuantity !== undefined) {
          return productData.availableQuantity;
        }
      }
      
      const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
      
      const keys = [
        `available_quantity_${cleanProductId}`,
        `available_quantity_${productId}`
      ];
      
      for (const key of keys) {
        const quantity = localStorage.getItem(key);
        if (quantity !== null) {
          const parsed = parseFloat(quantity);
          return parsed;
        }
      }
      
      const productData = getProductDataFromStorage(productId);
      if (productData && productData.availableQuantity !== undefined) {
        return productData.availableQuantity;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }


  function parseDecimalBR(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      return parseFloat(value.replace(',', '.')) || 0;
    }
    return 0;
  }

  function formatDecimalBR(value) {
    if (typeof value === 'string') {
      value = parseFloat(value.replace(',', '.'));
    }
    if (isNaN(value)) return '0,0';
    return value.toFixed(1).replace('.', ',');
  }

  function createAppProxyUrl(path) {
    return `/apps/${path || 'quantity-handler'}`;
  }

  const LOG_MAX_LEN = 600;
  function logSnippet(text) {
    try {
      if (typeof text !== 'string') return text;
      return text.length > LOG_MAX_LEN ? text.slice(0, LOG_MAX_LEN) + '…' : text;
    } catch (_e) {
      return text;
    }
  }

  function isRetryableStatus(status) {
    return [408, 429, 500, 502, 503, 504].includes(Number(status));
  }

  function extractUserMessageFromBody(body) {
    if (!body || typeof body !== 'string') return null;

    try {
      const parsed = JSON.parse(body);
      return parsed?.error || parsed?.message || null;
    } catch (_error) {
      return null;
    }
  }

  function getDefaultUserMessageForStatus(status) {
    if ([429, 503].includes(Number(status))) {
      return 'A loja esta processando muitos pedidos agora. Tente novamente em instantes.';
    }

    return null;
  }

  function getUserFacingErrorMessage(errorInfo, fallbackMessage = 'Nao foi possivel atualizar. Tente novamente.') {
    return errorInfo?.userMessage || extractUserMessageFromBody(errorInfo?.body) || errorInfo?.error || fallbackMessage;
  }


  async function timedFetch(url, options, label) {
    const t0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    const response = await fetch(url, options);
    const t1 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    return response;
  }

  async function timedFetchWithRetry(url, options, label, retryOptions = {}) {
    const retries = retryOptions.retries ?? 10;
    const delay = retryOptions.delay ?? Math.ceil(2000 / retries);
    let lastError = null;

    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        const response = await timedFetch(url, options, label);
        if (response.ok || attempt >= retries) {
          return response;
        }
      } catch (error) {
        lastError = error;
        if (attempt >= retries) {
          throw error;
        }
      }

      await new Promise(resolve => setTimeout(resolve, delay));
    }

    throw lastError || new Error(`${label || 'request'} failed`);
  }

  function shouldSuppressUpdateErrorMessage(errorInfo) {
    return Number(errorInfo?.status) === 422;
  }

  function shouldRestartUpdateCycle(errorInfo, attempt, maxAttempts) {
    return (Number(errorInfo?.status) === 422 || isRetryableStatus(errorInfo?.status)) && attempt < maxAttempts;
  }

  function saveProductData(productData) {
    try {
      if (!productData) return;
      const idCandidate = productData.productId || productData.id || productData.variantId;
      if (!idCandidate) return;
      const cleanId = idCandidate.toString().replace(/[^0-9]/g, '');
      const dataToStore = {
        ...productData,
        productId: cleanId,
        timestamp: Date.now()
      };
      localStorage.setItem(`product_data_${cleanId}`, JSON.stringify(dataToStore));
      if (typeof productData.availableQuantity === 'number' && !Number.isNaN(productData.availableQuantity)) {
        localStorage.setItem(`available_quantity_${cleanId}`, String(productData.availableQuantity));
      }
      if (typeof productData.originalQuantity === 'number' && !Number.isNaN(productData.originalQuantity)) {
        localStorage.setItem(`original_quantity_${cleanId}`, String(productData.originalQuantity));
      }
    } catch (err) {
    }
  }

  function showLoading() {
    const loading = document.getElementById('cart-loading-decimal');
    if (loading) loading.style.display = 'flex';
  }

  function hideLoading() {
    const loading = document.getElementById('cart-loading-decimal');
    if (loading) loading.style.display = 'none';
  }
  

  async function updateHeaderCartCountFromCart() {
    try {
      const res = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' } });
      if (!res.ok) return false;
      const cart = await res.json();
      const count = typeof cart.item_count === 'number' ? cart.item_count : (cart.items ? cart.items.length : 0);
      const targets = document.querySelectorAll('[data-cart-count]');
      targets.forEach(el => {
        try {
          el.textContent = String(count);
          el.setAttribute('data-cart-count', String(count));
          if (count > 0) {
            el.classList.remove('is-empty', 'hidden');
            el.style.display = '';
          } else {
            el.classList.add('is-empty');
          }
        } catch(_){}
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  function waitForElement(selector, timeout = 3000) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  }

  async function populateDrawerRecommendationsAsync() {
    try {
      await waitForElement('#cart-drawer-decimal .product-recommendations-inline');
      const root = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
      
      if (!root) {
        return;
      }
      
      if (hasDrawerRecommendationsInitialized) {
        return;
      }
      
      const wrapper = root.querySelector('.swiper-wrapper');
      const carousel = root.querySelector('[data-cart-drawer-recs]');
      
      if (!wrapper || !carousel) {
        return;
      }

      return populateDrawerRecommendations();
    } catch (e) {
    }
  }

  function populateDrawerRecommendations() {
    try {
      const root = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
      if (!root) return;
      
      if (hasDrawerRecommendationsInitialized) return;
      
      const wrapper = root.querySelector('.swiper-wrapper');
      const carousel = root.querySelector('[data-cart-drawer-recs]');
      if (!wrapper || !carousel) return;

      const limit = root.getAttribute('data-limit') || '8';

      function formatBRL(value) {
        const num = typeof value === 'string' ? parseFloat(value) : value;
        // Preços de /recommendations/products.json e /products/*.js vêm sempre em centavos
        // (inteiros); o limiar antigo (> 1000) exibia R$ 9,00 como R$ 900,00
        const amount = Number.isInteger(num) ? (num / 100) : num;
        try {
          return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount || 0);
        } catch(_) {
          return 'R$ ' + (amount || 0).toFixed(2).replace('.', ',');
        }
      }

      function renderProducts(products) {
        if (!products || !products.length) {
          root.style.display = 'none';
          return;
        }
        wrapper.innerHTML = '';
        products.forEach((p) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          const a = document.createElement('a');
          a.className = 'card-product-cart';
          a.href = p.url || (p.handle ? ('/' + p.handle) : '#');
          const imgSrc = ((p.featured_image && (p.featured_image.url || p.featured_image)) || '');
          const title = (p.title || '').replace(/"/g, '&quot;');
          let priceHtml = '';
          const priceNow = p.price || p.price_min || p.price_max;
          if (priceNow) {
            priceHtml = `<div class="card-product-cart-price"><span class="price-now">${formatBRL(priceNow)}</span><span class="price-unit" style="font-size: 1.2rem; color: #a4a4a4;"> /metro</span></div>`;
          }
          a.innerHTML = `
            <div class="card-product-cart-image">
              <img src="${imgSrc}" alt="${title}">
            </div>
            <div class="card-product-cart-info">
              <div class="card-product-cart-name"><h3>${title}</h3></div>
              ${priceHtml}
            </div>`;
          slide.appendChild(a);
          wrapper.appendChild(slide);
        });
        if (typeof Swiper !== 'undefined') {
          if (!carousel.classList.contains('swiper-initialized')) {
            new Swiper(carousel, {
              slidesPerView: 3.4,
              slidesPerGroup: 1,
              spaceBetween: 5,
              watchSlidesProgress: true,
              navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
              autoplay: { delay: 7000, disableOnInteraction: false },
              breakpoints: {
                768: { spaceBetween: 5, slidesPerView: 4, },
              },
              on: {
                init: function() {
                  const recSection = document.querySelector('#cart-drawer-decimal .cart-drawer-recommendations');
                  if (recSection) recSection.classList.add('is-ready');
                  hasDrawerRecommendationsInitialized = true;
                }
              }
            });
          }
        }
      }

      function loadWithProductId(productId) {
        const url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related';
        fetch(url)
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            const recs = (data && (data.products || data)) || [];
            const needsDetails = recs.some(p => !(p.price || p.price_min));
            if (!needsDetails) return recs;
            return Promise.all(recs.map(p => {
              if (!p.handle) return p;
              return fetch('/products/' + p.handle + '.js')
                .then(r => r.ok ? r.json() : null)
                .then(d => {
                  if (d && d.variants && d.variants.length) {
                    const prices = d.variants.map(v => (typeof v.price === 'string' ? parseFloat(v.price) : v.price));
                    const compare = d.variants.map(v => (typeof v.compare_at_price === 'string' ? parseFloat(v.compare_at_price) : v.compare_at_price)).filter(Boolean);
                    p.price = Math.min.apply(null, prices.filter(Boolean));
                    if (compare.length) p.compare_at_price = Math.max.apply(null, compare);
                  }
                  return p;
                })
                .catch(() => p);
            }));
          })
          .then((recs) => { if (recs) renderProducts(recs); })
          .catch(() => { root.style.display = 'none'; });
      }

      const explicitPid = root.getAttribute('data-product-id');
      if (explicitPid) {
        loadWithProductId(explicitPid);
      } else {
        fetch('/cart.js')
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            const pid = cart && cart.items && cart.items[0] && cart.items[0].product_id;
            if (pid) loadWithProductId(pid); else root.style.display = 'none';
          })
          .catch(() => { root.style.display = 'none'; });
      }
    } catch (_e) {}
  }

  function initCartDrawerCarousel() {
    try {
      const carouselElement = document.querySelector('#cart-drawer-decimal [data-cart-drawer-carousel]');
      if (!carouselElement) return;
      if (carouselElement.classList.contains('swiper-initialized')) return;

      if (typeof Swiper === 'undefined') return;
      const swiper = new Swiper(carouselElement, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          init: function() {
            carouselElement.classList.add('swiper-initialized');
          }
        }
      });
      return swiper;
    } catch (e) {
    }
  }

  function setDrawerProcessing(enabled) {
    try {
      const drawer = document.getElementById('cart-drawer-decimal');
      if (!drawer) return;

      const buttons = drawer.querySelectorAll('.quantity-edit-button, .quantity-confirm, .quantity-cancel, .remove-item, .checkout-button');
      buttons.forEach((btn) => {
        if (!btn) return;
        btn.disabled = enabled;
        btn.style.cursor = enabled ? 'not-allowed' : 'pointer';
      });

      if (enabled) {
        showLoading();
      } else {
        hideLoading();
      }
    } catch (err) {
    }
  }

  function isCartTemplate() {
    return document.body.classList.contains('template-cart') || 
           window.location.pathname === '/cart' ||
           window.location.pathname.includes('/cart');
  }

  function openCartDrawer() {
    // Não abrir o drawer se estivermos no template cart
    if (isCartTemplate()) {
      return;
    }
    
    const drawer = document.getElementById('cart-drawer-decimal');
    if (drawer) {
      drawer.classList.add('open');
      isDrawerOpen = true;
      document.body.classList.add('drawer-open');
      
      const overlay = drawer.querySelector('.drawer-overlay');
      if (overlay) {
        overlay.classList.add('is-visible');
      }

      if (!hasDrawerContentInitialized) {
        refreshCartData().then(async () => {
          try {
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
            initCartDrawerCarousel();
          } catch (e) {
          }
        }).catch(async () => {
          try {
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
            initCartDrawerCarousel();
          } catch (e) {}
        });
        hasDrawerContentInitialized = true;
      } else {
        setTimeout(async () => {
          try {
          initCartDrawerCarousel && initCartDrawerCarousel();
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
          } catch (e) {
          }
        }, 50);
      }
    }
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer-decimal');
    if (drawer) {
      drawer.classList.remove('open');
      isDrawerOpen = false;
      document.body.classList.remove('drawer-open');
      
      const overlay = drawer.querySelector('.drawer-overlay');
      if (overlay) {
        overlay.classList.remove('is-visible');
      }
    }
  }

  async function getCartData() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function refreshCartDataComplete() {
    showLoading();
    
    try {
      const response = await fetch(`?section_id=cart-drawer-decimal`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const section = doc.querySelector('#shopify-section-cart-drawer-decimal');
      const cartDrawerContent = section ? section.querySelector('.cart-drawer-content') : doc.querySelector('.cart-drawer-content');
      
      if (cartDrawerContent) {
        const currentContent = document.querySelector('.cart-drawer-content');
        if (currentContent) {
          currentContent.innerHTML = cartDrawerContent.innerHTML;
          
          const newDrawer = cartDrawerContent.closest('#cart-drawer-decimal') || section?.querySelector('#cart-drawer-decimal');
          const currentDrawer = document.getElementById('cart-drawer-decimal');
          if (newDrawer && currentDrawer) {
            if (newDrawer.classList.contains('cart-empty')) {
              currentDrawer.classList.add('cart-empty');
            } else {
              currentDrawer.classList.remove('cart-empty');
            }
          }
          
          const cartItemsComplete = currentContent.querySelectorAll('.cart-item-decimal');
          const cartEmptyDivComplete = currentContent.querySelector('.cart-empty');
          const isEmptyComplete = cartItemsComplete.length === 0 || !!cartEmptyDivComplete;
          const currentDrawerComplete = document.getElementById('cart-drawer-decimal');
          
          if (currentDrawerComplete) {
            if (isEmptyComplete && !currentDrawerComplete.classList.contains('cart-empty')) {
              currentDrawerComplete.classList.add('cart-empty');
            } else if (!isEmptyComplete && currentDrawerComplete.classList.contains('cart-empty')) {
              currentDrawerComplete.classList.remove('cart-empty');
            }
          }
          
          persistCartKeyProductMapFromDOM();
          
          setTimeout(() => {
            initializeDrawerEvents();
          }, 50);
        }
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      window.location.reload();
    } finally {
      hideLoading();
    }
  }

  async function refreshCartData() {
    if (isUpdating) {
      return;
    }
    
    showLoading();
    
    try {
      const response = await fetch(`?section_id=cart-drawer-decimal`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const section = doc.querySelector('#shopify-section-cart-drawer-decimal');
      const cartDrawerContent = section ? section.querySelector('.cart-drawer-content') : doc.querySelector('.cart-drawer-content');
      
      if (cartDrawerContent) {
        const currentContent = document.querySelector('.cart-drawer-content');
        
        if (currentContent) {
          const newProgressBars = cartDrawerContent.querySelectorAll('[id^="progress-bar-"]');
          const currentProgressBars = currentContent.querySelectorAll('[id^="progress-bar-"]');
          
          if (newProgressBars.length > 0) {
            currentProgressBars.forEach(bar => bar.remove());
            
            const header = currentContent.querySelector('.cart-drawer-header');
            if (header) {
              newProgressBars.forEach((bar, index) => {
                header.insertAdjacentHTML('afterend', bar.outerHTML);
              });
            }
          } else if (currentProgressBars.length > 0) {
            currentProgressBars.forEach(bar => bar.remove());
          }
          
          const newBody = cartDrawerContent.querySelector('.cart-drawer-body');
          const currentBody = currentContent.querySelector('.cart-drawer-body');
          if (newBody && currentBody) {
            currentBody.innerHTML = newBody.innerHTML;
          }
          
          const newDrawer = cartDrawerContent.closest('#cart-drawer-decimal') || section?.querySelector('#cart-drawer-decimal');
          const currentDrawer = document.getElementById('cart-drawer-decimal');
          if (newDrawer && currentDrawer) {
            if (newDrawer.classList.contains('cart-empty')) {
              currentDrawer.classList.add('cart-empty');
            } else {
              currentDrawer.classList.remove('cart-empty');
            }
          }
          
          const cartItems = currentContent.querySelectorAll('.cart-item-decimal');
          const cartEmptyDiv = currentContent.querySelector('.cart-empty');
          const isEmpty = cartItems.length === 0 || !!cartEmptyDiv;
          const currentDrawerFinal = document.getElementById('cart-drawer-decimal');
          
          if (currentDrawerFinal) {
            if (isEmpty && !currentDrawerFinal.classList.contains('cart-empty')) {
              currentDrawerFinal.classList.add('cart-empty');
            } else if (!isEmpty && currentDrawerFinal.classList.contains('cart-empty')) {
              currentDrawerFinal.classList.remove('cart-empty');
            }
          }

          persistCartKeyProductMapFromDOM();
          
          setTimeout(() => {
            const quantityInputs = document.querySelectorAll('#cart-drawer-decimal .quantity-input');
            
            quantityInputs.forEach((input, index) => {
              if (input.value && input.value.includes(',')) {
                const americanValue = input.value.replace(',', '.');
                input.value = americanValue;
                if (!input.dataset.originalValue) {
                  input.dataset.originalValue = americanValue;
                }
              }
            });
            
            initializeQuantityControls();
            // Update minimum order display after refresh
            getCartData().then(cart => {
              if (cart) {
                updateMinimumOrderDisplay(cart);
              }
            }).catch(() => {});
            
            // Initial update when page loads
            setTimeout(() => {
              getCartData().then(cart => {
                if (cart) {
                  updateMinimumOrderDisplay(cart);
                }
              }).catch(() => {});
            }, 200);
          }, 50);
        }
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      window.location.reload();
    } finally {
      hideLoading();
    }
  }

  async function updateCartQuantity(key, decimalQuantity, realQuantity) {
    if (isUpdating) return false;
    isUpdating = true;
    
    showLoading();

    try {
      let currentStep = 'prepare';
      lastUpdateErrorInfo = { step: currentStep, key, decimalQuantity, realQuantity };

      const itemElement = document.querySelector(`.cart-item-decimal[data-key="${key}"]`);
      if (!itemElement) {
        lastUpdateErrorInfo = { step: 'prepare', reason: 'itemElement not found', key };
        window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
        return false;
      }
      const productIdRaw = itemElement?.dataset.productId || '';
      let productIdGid = productIdRaw;
      if (productIdGid && !productIdGid.startsWith('gid://')) {
        productIdGid = `gid://shopify/Product/${productIdGid}`;
      }
      if (!productIdGid) {
        lastUpdateErrorInfo = { step: 'prepare', reason: 'missing productId', dataset: { ...itemElement.dataset } };
        window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
        return false;
      }
      const pricePerMeter = parseFloat(itemElement?.dataset.pricePerMeter || '0');
      if (!Number.isFinite(pricePerMeter) || pricePerMeter <= 0) {
        lastUpdateErrorInfo = { step: 'prepare', reason: 'invalid pricePerMeter', value: itemElement?.dataset.pricePerMeter };
        window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
        return false;
      }
      const productTitle = itemElement?.querySelector('.cart-item-title')?.textContent?.trim() || '';

      const maxAddRestartAttempts = 10;
      for (let addRestartAttempt = 1; addRestartAttempt <= maxAddRestartAttempts; addRestartAttempt++) {
        currentStep = 'proxy';
        const proxyUrl = createAppProxyUrl('quantity-handler');
        const proxyBody = {
          productId: productIdGid,
          quantidade: decimalQuantity.toFixed(1),
          quantidadeReal: realQuantity,
          precoMetro: pricePerMeter,
          titulo: productTitle,
          extra: {
            handle: itemElement?.dataset.productHandle || '',
            image: itemElement.querySelector('img')?.src || '',
            pricePerMeter: pricePerMeter,
            availableQuantity: parseFloat(itemElement?.dataset.availableQuantity || '0') || undefined,
            originalQuantity: parseFloat(itemElement?.dataset.originalQuantity || '0') || undefined
          }
        };
        const variantResp = await timedFetchWithRetry(proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(proxyBody)
        }, 'AppProxy/quantity-handler');

        if (!variantResp.ok) {
          const errorText = logSnippet(await variantResp.text().catch(() => ''));
          lastUpdateErrorInfo = {
            step: 'proxy',
            status: variantResp.status,
            statusText: variantResp.statusText,
            body: errorText,
            userMessage: extractUserMessageFromBody(errorText) || getDefaultUserMessageForStatus(variantResp.status),
            retryable: isRetryableStatus(variantResp.status),
            attempt: addRestartAttempt,
            maxAttempts: maxAddRestartAttempts
          };
          window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
          if (shouldRestartUpdateCycle(lastUpdateErrorInfo, addRestartAttempt, maxAddRestartAttempts)) {
            await new Promise(resolve => setTimeout(resolve, Math.ceil(2000 / maxAddRestartAttempts)));
            continue;
          }
          return false;
        }
        let variantResult = null;
        try {
          variantResult = await variantResp.json();
        } catch (jsonErr) {
          lastUpdateErrorInfo = { step: 'proxy.json', error: jsonErr?.message || jsonErr, attempt: addRestartAttempt, maxAttempts: maxAddRestartAttempts };
          window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
          return false;
        }
        if (!variantResult.success || !variantResult.variant?.id) {
          lastUpdateErrorInfo = {
            step: 'proxy.result',
            result: variantResult,
            status: variantResult?.status,
            userMessage: variantResult?.error || variantResult?.message,
            retryable: isRetryableStatus(variantResult?.status),
            attempt: addRestartAttempt,
            maxAttempts: maxAddRestartAttempts
          };
          window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
          if (variantResult?.status === 422 && shouldRestartUpdateCycle({ status: 422 }, addRestartAttempt, maxAddRestartAttempts)) {
            lastUpdateErrorInfo.status = 422;
            await new Promise(resolve => setTimeout(resolve, Math.ceil(2000 / maxAddRestartAttempts)));
            continue;
          }
          return false;
        }

      try {
        const storagePayload = {
          id: itemElement?.dataset.productId,
          productId: itemElement?.dataset.productId,
          title: productTitle,
          handle: itemElement?.dataset.productHandle || '',
          featured_image: itemElement.querySelector('img')?.src || '',
          price: pricePerMeter,
          availableQuantity: parseFloat(itemElement?.dataset.availableQuantity || '0') || undefined,
          originalQuantity: parseFloat(itemElement?.dataset.originalQuantity || '0') || undefined
        };
        saveProductData(storagePayload);
      } catch (_e) {}

        const newVariantId = variantResult.variant.id.split('/').pop();

      currentStep = 'remove';
      
      // Primeiro, tentar encontrar o item no carrinho atual para usar line parameter
      let removeResp = null;
      try {
        const cartStateResp = await timedFetch('/cart.js', { method: 'GET' }, 'Cart/state');
        const cartState = await cartStateResp.json();
        
        let idx = cartState.items.findIndex(i => i.key === key);
        
        if (idx < 0) {
          const oldDecimalStr = (parseFloat(itemElement?.dataset.decimalQuantity || '0') || 0).toFixed(1) + ' metros';
          const productIdNum = parseInt((itemElement?.dataset.productId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
          idx = cartState.items.findIndex(i => {
            const sameProduct = (parseInt(i.product_id, 10) === productIdNum);
            const sameQtyProp = (i.properties && (i.properties['_Quantidade'] === oldDecimalStr));
            return sameProduct && sameQtyProp;
          });
        }
        
        if (idx < 0) {
          const handle = itemElement?.dataset.productHandle || '';
          if (handle) {
            idx = cartState.items.findIndex(i => i.handle === handle);
          }
        }
        
        if (idx >= 0) {
          // Usar line parameter primeiro (mais confiável)
          const lineBody = { line: idx + 1, quantity: 0 };
          removeResp = await timedFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(lineBody)
          }, 'Cart/change(remove,line)');
        } else if (addRestartAttempt > 1) {
          removeResp = { ok: true };
        } else {
          // Fallback para id parameter
          const removeBody = { id: key, quantity: 0 };
          removeResp = await timedFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(removeBody)
          }, 'Cart/change(remove,id)');
        }
        } catch (e) {
          if (addRestartAttempt > 1) {
            removeResp = { ok: true };
          } else {
          // Fallback para id parameter
          const removeBody = { id: key, quantity: 0 };
          removeResp = await timedFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(removeBody)
          }, 'Cart/change(remove,id)');
          }
        }
        
        if (!removeResp.ok) {
          const removeText = logSnippet(await removeResp.text().catch(() => ''));
        lastUpdateErrorInfo = { step: 'remove', status: removeResp.status, statusText: removeResp.statusText, body: removeText, attempt: addRestartAttempt, maxAttempts: maxAddRestartAttempts };
        window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
        return false;
      }

      currentStep = 'add';
      const formattedPricePerMeter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(pricePerMeter);
      const addBody = {
        items: [{
          id: parseInt(newVariantId, 10),
          quantity: realQuantity,
          properties: {
            '_Quantidade': `${decimalQuantity.toFixed(1)} metros`,
            'Valor por metro': formattedPricePerMeter
          }
        }]
      };
      const addResp = await timedFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addBody)
      }, 'Cart/add');
      if (!addResp.ok) {
        const addText = logSnippet(await addResp.text().catch(() => ''));
        lastUpdateErrorInfo = { step: 'add', status: addResp.status, statusText: addResp.statusText, body: addText, attempt: addRestartAttempt, maxAttempts: maxAddRestartAttempts };
        window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
        if (shouldRestartUpdateCycle(lastUpdateErrorInfo, addRestartAttempt, maxAddRestartAttempts)) {
          await new Promise(resolve => setTimeout(resolve, Math.ceil(2000 / maxAddRestartAttempts)));
          continue;
        }
        return false;
      }

      try {
        const addResult = await addResp.json();
        const newItem = addResult?.items?.[0];
        if (newItem) {
          saveProductData({
            id: itemElement?.dataset.productId,
            productId: itemElement?.dataset.productId,
            title: newItem.product_title || productTitle,
            handle: newItem.handle || itemElement?.dataset.productHandle || '',
            featured_image: newItem.image || itemElement.querySelector('img')?.src || '',
            price: pricePerMeter,
            availableQuantity: parseFloat(itemElement?.dataset.availableQuantity || '0') || undefined,
            originalQuantity: parseFloat(itemElement?.dataset.originalQuantity || '0') || undefined
          });
        }
      } catch (_e) {}

      currentStep = 'inplace-ui';
      const numericProductId = (itemElement?.dataset.productId || '').toString().replace(/[^0-9]/g, '');
      await updateDrawerUIInPlace({
        itemElement,
        pricePerMeter,
        decimalQuantity,
        realQuantity,
        productId: numericProductId,
        newVariantId
      });
      return true;
      }

      return false;
    } catch (error) {
      lastUpdateErrorInfo = { step: 'catch', error: error?.message || error };
      window.cartDrawerDecimalLastError = lastUpdateErrorInfo;
      return false;
    } finally {
      isUpdating = false;
    }
  }

  async function removeCartItem(key) {
    if (isUpdating) {
      let attempts = 0;
      while (isUpdating && attempts < 10) {
        await new Promise(resolve => setTimeout(resolve, 200));
        attempts++;
      }
      
      if (isUpdating) {
        return false;
      }
    }
    
    isUpdating = true;
    
    showLoading();
    
    let cartItem = document.querySelector(`[data-key="${key}"], .cart-item-decimal[data-key="${key}"]`);
    let currentKey = key;
    
    if (!cartItem) {
      const allRemoveButtons = document.querySelectorAll('#cart-drawer-decimal .remove-item');
      for (const btn of allRemoveButtons) {
        const btnKey = btn.dataset.key;
        if (btnKey && btnKey !== key) {
          const possibleItem = document.querySelector(`[data-key="${btnKey}"]`);
          if (possibleItem) {
            cartItem = possibleItem;
            currentKey = btnKey;
            break;
          }
        }
      }
    }
    
    const decimalQty = cartItem ? parseFloat(cartItem.dataset.decimalQuantity) || 0 : 0;
    const realQty = cartItem ? parseInt(cartItem.dataset.realQuantity) || 0 : 0;
    
    try {
      const currentCartResp = await fetch('/cart.js', { method: 'GET' });
      if (currentCartResp.ok) {
        const currentCart = await currentCartResp.json();
        const originalKeyExists = currentCart.items?.some(item => item.key === key);
        const currentKeyExists = currentCart.items?.some(item => item.key === currentKey);
        
        if (!originalKeyExists && currentKeyExists) {
        }
      }
    } catch (e) {
    }
    
    try {
      // Primeiro, tentar encontrar o item no carrinho atual para usar line parameter
      let removeResp = null;
      try {
        const cartStateResp = await fetch('/cart.js', { method: 'GET' });
        const cartState = await cartStateResp.json();
        
        let idx = cartState.items.findIndex(i => i.key === currentKey);
        
        if (idx < 0) {
          // Buscar por produto e quantidade
          const oldDecimalStr = (parseFloat(cartItem?.dataset.decimalQuantity || '0') || 0).toFixed(1) + ' metros';
          const productIdNum = parseInt((cartItem?.dataset.productId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
          idx = cartState.items.findIndex(i => {
            const sameProduct = (parseInt(i.product_id, 10) === productIdNum);
            const sameQtyProp = (i.properties && (i.properties['_Quantidade'] === oldDecimalStr));
            return sameProduct && sameQtyProp;
          });
        }
        
        if (idx < 0) {
          // Buscar por handle
          const handle = cartItem?.dataset.productHandle || '';
          if (handle) {
            idx = cartState.items.findIndex(i => i.handle === handle);
          }
        }
        
        if (idx >= 0) {
          // Usar line parameter primeiro (mais confiável)
          const lineBody = { line: idx + 1, quantity: 0 };
          removeResp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(lineBody)
          });
        } else {
          // Fallback para id parameter
          const removeBody = { id: currentKey, quantity: 0 };
          removeResp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(removeBody)
          });
        }
      } catch (e) {
        // Fallback para id parameter
        const removeBody = { id: currentKey, quantity: 0 };
        removeResp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(removeBody)
        });
      }

      if (removeResp.ok) {
        const result = await removeResp.json();
        
        const wasUpdating = isUpdating;
        isUpdating = false;
        
        await refreshCartDataComplete();
        
        isUpdating = wasUpdating;
        
        try { await updateSubtotalFromCart(); } catch (_) {}
        try { await updateHeaderCartCountFromCart(); } catch (_) {}
        
        setTimeout(() => {
          const remainingItem = document.querySelector(`[data-key="${key}"]`);
          if (remainingItem) {
            remainingItem.remove();
          }
          
          // Disparar evento customizado para notificar remoção de item
          document.dispatchEvent(new CustomEvent('cartItemRemoved', {
            detail: { key, productId: cartItem?.dataset.productId }
          }));
        }, 100);
        
        return true;
      } else {
        try {
          const errorText = await removeResp.text();
        } catch (e) {
        }
        
        window.location.reload();
        return false;
      }
    } catch (error) {
      window.location.reload();
      return false;
    } finally {
      hideLoading();
      isUpdating = false;
    }
  }

  async function updateSubtotalFromCart() {
    try {
      const res = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' } });
      if (!res.ok) throw new Error('cart.js request failed: ' + res.status);
      const cart = await res.json();
      
      
      // Use total_price for subtotal (like cart decimal does) - this includes discounts
      const subtotalCents = cart.total_price || 0;
      
      const subtotalElement = document.querySelector('#cart-drawer-decimal .subtotal');
      if (subtotalElement) {
        const formattedSubtotal = formatMoneyCentsBRL(subtotalCents);
        subtotalElement.textContent = `Subtotal: ${formattedSubtotal}`;
        } else {
          // Elemento subtotal não encontrado
        }
      
      // Update minimum order display (only show/hide, message comes from Liquid)
      updateMinimumOrderDisplay(cart);
      
      return true;
    } catch (error) {
      console.error('❌ Erro ao atualizar subtotal:', error);
      return false;
    }
  }

  function isPixDiscount(discount) {
    const title = String(discount?.title || discount?.code || discount?.discount_application?.title || '').toLowerCase();
    return title.includes('pix');
  }

  function getAppliedCouponDiscounts(discounts = []) {
    return discounts.filter(discount => discount.type === 'discount_code' && !isPixDiscount(discount));
  }

  function updateDiscountDisplay(cart) {
    const discountDiv = document.getElementById('cart-drawer-discount');
    const discountValue = document.getElementById('cart-drawer-discount-value');
    const appliedCouponDiv = document.getElementById('cart-drawer-applied-coupon');
    const appliedCouponCode = document.getElementById('cart-drawer-applied-coupon-code');

    if (!discountDiv || !discountValue) {
      return;
    }

    // Check if there are applied discounts
    
    // Check for cart-level discounts first
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      const appliedCoupons = getAppliedCouponDiscounts(cart.cart_level_discount_applications);
      
      if (appliedCoupons.length > 0) {
        const appliedCoupon = appliedCoupons[0];
        const couponCode = appliedCoupon.title;
        const discountAmount = appliedCoupon.total_allocated_amount || 0;
        
        // Show applied coupon
        if (appliedCouponCode) {
          appliedCouponCode.textContent = couponCode.toUpperCase();
        }
        if (appliedCouponDiv) {
          appliedCouponDiv.style.display = 'flex';
        }
        
        // Show discount with actual amount
        discountDiv.style.display = 'flex';
        const formattedAmount = formatMoneyCentsBRL(discountAmount);
        const displayValue = formattedAmount.startsWith('-') ? formattedAmount : `-${formattedAmount}`;
        discountValue.textContent = displayValue;
        
        return;
      }
    }
    
    // Check for item-level discounts or price changes (product-level discounts)
    const hasPriceChange = cart.original_total_price && cart.total_price && 
                          cart.total_price < cart.original_total_price;
    
    if (hasPriceChange) {
      const discountAmount = cart.original_total_price - cart.total_price;
      
      // Get the coupon code directly from cart data
      let couponCode = 'CUPOM';
      
      // Look for coupon code in cart items
      if (cart.items && cart.items.length > 0) {
        for (const item of cart.items) {
          // Check item properties for discount code
          if (item.properties) {
            
            // Look for discount code in properties
            for (const [key, value] of Object.entries(item.properties)) {
              if (key.toLowerCase().includes('discount') || key.toLowerCase().includes('coupon') || key.toLowerCase().includes('code')) {
                couponCode = value;
                break;
              }
            }
          }
          
          // Check line level discount allocations
          if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
            const discountAllocation = item.line_level_discount_allocations.find(allocation => 
              allocation.discount_application && allocation.discount_application.type === 'discount_code' && !isPixDiscount(allocation.discount_application)
            );
            if (discountAllocation) {
              couponCode = discountAllocation.discount_application.title;
              break;
            }
          }
          
          // Check discounts array
          if (item.discounts && item.discounts.length > 0) {
            const discount = item.discounts.find(d => d.title && !isPixDiscount(d));
            if (discount) {
              couponCode = discount.title;
              break;
            }
          }
          
          if (couponCode !== 'CUPOM') break; // Found it!
        }
      }
      
      if (couponCode === 'CUPOM') {
        // Try to get from localStorage as fallback
        const storedCoupon = localStorage.getItem('lastAppliedCoupon');
        if (storedCoupon) {
          couponCode = storedCoupon;
        }
      }
      
      // Show applied coupon
      if (appliedCouponCode) {
        appliedCouponCode.textContent = couponCode.toUpperCase();
      }
      if (appliedCouponDiv) {
        appliedCouponDiv.style.display = 'flex';
      }
      
      // Show discount with calculated amount
      discountDiv.style.display = 'flex';
      const formattedAmount = formatMoneyCentsBRL(discountAmount);
      const displayValue = formattedAmount.startsWith('-') ? formattedAmount : `-${formattedAmount}`;
      discountValue.textContent = displayValue;
    } else {
      // Hide discount if no discounts at all
      discountDiv.style.display = 'none';
      if (appliedCouponDiv) {
        appliedCouponDiv.style.display = 'none';
      }
    }
  }

  function updateMinimumOrderDisplay(cart) {
    const minimumWarning = document.getElementById('minimum-order-warning');
    const checkoutButton = document.querySelector('#cart-drawer-decimal .checkout-button');
    
    if (!minimumWarning && !checkoutButton) {
      return;
    }

    // Get minimum order value from data attribute
    const minimumValueCents = minimumWarning ? parseInt(minimumWarning.getAttribute('data-minimum')) : 5000;
    
    const subtotalCents = cart.total_price || cart.items_subtotal_price || 0;
    
    const isMinimumReached = subtotalCents >= minimumValueCents;

    // Control display and update message dynamically
    if (minimumWarning) {
      if (isMinimumReached) {
        minimumWarning.style.display = 'none';
      } else {
        minimumWarning.style.display = 'flex';
        
        // Update message with current values
        const remainingCents = minimumValueCents - subtotalCents;
        const remainingFormatted = formatMoneyCentsBRL(remainingCents);
        const minimumFormatted = formatMoneyCentsBRL(minimumValueCents);
        
        const messageElement = minimumWarning.querySelector('.minimum-order-title');
        const detailElement = minimumWarning.querySelector('.minimum-order-detail');
        
        if (messageElement && detailElement) {
          messageElement.textContent = `Valor mínimo do pedido: ${minimumFormatted}`;
          detailElement.textContent = `Adicione mais ${remainingFormatted} para finalizar sua compra`;
        }
      }
    }

    // Control checkout button
    if (checkoutButton) {
      if (isMinimumReached) {
        // Enable checkout button
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
        if (checkoutButton.tagName === 'BUTTON') {
          // Convert button to link if it was disabled
          const link = document.createElement('a');
          link.href = '/checkout';
          link.className = checkoutButton.className.replace('disabled', '');
          link.innerHTML = checkoutButton.innerHTML;
          checkoutButton.parentNode.replaceChild(link, checkoutButton);
        }
      } else {
        // Disable checkout button
        if (checkoutButton.tagName === 'A') {
          // Convert link to button if it was enabled
          const button = document.createElement('button');
          button.type = 'button';
          button.className = checkoutButton.className + ' disabled';
          button.disabled = true;
          button.innerHTML = checkoutButton.innerHTML;
          checkoutButton.parentNode.replaceChild(button, checkoutButton);
        } else {
          checkoutButton.disabled = true;
          checkoutButton.classList.add('disabled');
        }
      }
    }
  }

  function updateSubtotal() {
    try {
      // updateSubtotal() chamada - esta função não considera descontos!
      // Esta função não deve ser usada quando há descontos aplicados
      // Ela calcula apenas o subtotal dos itens sem considerar cupons
      const cartItems = document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal');
      let total = 0;
      
      cartItems.forEach(item => {
        const pricePerMeter = parseFloat(item.dataset.pricePerMeter || '0');
        const decimalQuantity = parseFloat(item.dataset.decimalQuantity || '0');
        const realQuantity = parseInt(item.dataset.realQuantity || '1', 10);
        
        if (pricePerMeter > 0 && decimalQuantity > 0 && realQuantity > 0) {
          const lineTotal = pricePerMeter * decimalQuantity * realQuantity;
          total += lineTotal;
        }
      });
      
      const subtotalElement = document.querySelector('#cart-drawer-decimal .subtotal');
      if (subtotalElement) {
        subtotalElement.textContent = `Subtotal: ${formatMoneyCentsBRL(Math.round(total * 100))}`;
      }
    } catch (error) {
    }
  }

  function formatMoneyCentsBRL(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (_e) {}
    const amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
    } catch (_e2) {
      return 'R$ ' + amount.toFixed(2).replace('.', ',');
    }
  }

  async function updateDrawerUIInPlace({ itemElement, pricePerMeter, decimalQuantity, realQuantity, productId, newVariantId }) {
    try {
      const lineTotal = pricePerMeter * decimalQuantity * realQuantity;
      const priceElement = itemElement.querySelector('.cart-item-price');
      if (priceElement) {
        priceElement.textContent = formatMoneyCentsBRL(Math.round(lineTotal * 100));
      }
      const input = itemElement.querySelector('.quantity-input');
      if (input) {
        input.value = decimalQuantity.toFixed(1).replace('.', ',');
        input.dataset.originalValue = decimalQuantity.toFixed(1);
      }
      itemElement.dataset.decimalQuantity = String(decimalQuantity);
      itemElement.dataset.realQuantity = String(realQuantity);

      const cartResp = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Cache-Control': 'no-store' } });
      if (!cartResp.ok) return;
      const cart = await cartResp.json();

      const subtotal = parseInt(cart.total_price || cart.items_subtotal_price || 0, 10);
      
      const allProgressBars = document.querySelectorAll('[id^="progress-bar-"]');
      
      allProgressBars.forEach((progressBar, index) => {
        const barId = progressBar.id;
        const barNumber = barId.replace('progress-bar-', '');
        const progressEl = document.getElementById(`shipping-progress-${barNumber}`);
        
      if (progressEl) {
        const max = parseInt(progressEl.getAttribute('max') || '0', 10) || 0;
          const threshold = parseInt(progressBar.getAttribute('data-threshold') || '0', 10) || 0;
          const name = progressBar.getAttribute('data-name') || '';
          
          const effectiveThreshold = threshold || max;
          
          progressEl.setAttribute('value', String(subtotal));
          progressEl.setAttribute('max', String(effectiveThreshold));
          
          const label = progressBar.querySelector('.shipping-message') || progressEl.closest('.progress-bar')?.querySelector('label');
        if (label) {
            if (subtotal >= effectiveThreshold && effectiveThreshold > 0) {
              label.textContent = `Você ganhou frete grátis para ${name}!`;
            } else if (effectiveThreshold > 0) {
              const restante = Math.max(0, effectiveThreshold - subtotal);
              label.textContent = `Faltam ${formatMoneyCentsBRL(restante)} para frete grátis ${name}`;
            }
          }
        }
      });

      const productIdNum = parseInt((productId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
      const desiredQtyStr = `${decimalQuantity.toFixed(1)} metros`;
      const newVariantNum = parseInt((newVariantId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
      const matched = (cart.items || []).find((i) => {
        const sameProduct = parseInt(i.product_id, 10) === productIdNum;
        const samePropQty = i.properties && i.properties['_Quantidade'] === desiredQtyStr;
        const sameVariant = !newVariantNum || parseInt(i.variant_id, 10) === newVariantNum;
        return sameProduct && samePropQty && sameVariant;
      });
      
      if (matched && matched.key) {
        const oldKey = itemElement.dataset.key || '';
        const newKey = matched.key;
        
        itemElement.dataset.key = newKey;
        
        const removeButtons = itemElement.querySelectorAll('.remove-item');
        removeButtons.forEach(btn => {
          const oldBtnKey = btn.dataset.key;
          btn.dataset.key = newKey;
          
          btn.setAttribute('data-key', newKey);
        });
        
        const map = getCartKeyToProductMap();
        const cleanPid = String(productIdNum);
        if (oldKey && map[oldKey]) {
          delete map[oldKey];
        }
        map[newKey] = cleanPid;
        saveCartKeyToProductMap(map);
      }

      // Sempre usar updateSubtotalFromCart para manter consistência com descontos
      await updateSubtotalFromCart();
    } catch (error) {
    }
  }

  function validateStock(item, decimalQuantity, realQuantity) {
    let productId = item.dataset.productId || item.dataset.variantId;
    
      const cartKey = item.dataset.key;
      if (cartKey) {
      const mapped = extractProductIdFromKey(cartKey);
      if ((!productId || productId === 'null') && mapped) {
        productId = mapped;
      } else if (productId && productId !== 'null') {
        const hasStored = (getAvailableQuantityFromStorage(productId) !== null) || !!getProductDataFromStorage(productId);
        if (!hasStored && mapped) {
          productId = mapped;
        }
      }
    }
    
    // SEMPRE usar o valor do metafield quantidade_decimal_disponivel do Liquid
    // que já considera o estoque disponível real calculado no Liquid
    let availableQuantity = parseFloat(item.dataset.availableQuantity) || 999;
    
    // NÃO sobrescrever com dados do localStorage - sempre usar o metafield
    // O template Liquid já calcula a disponibilidade considerando produtos duplicados
    
    const totalRequested = decimalQuantity * realQuantity;
    
    if (totalRequested > availableQuantity) {
      showStockTooltip(item, `Disponível: ${availableQuantity.toFixed(1).replace('.', ',')}m`, 'error');
      return false;
    }
    
    hideStockTooltip(item);
    return true;
  }

  function showStockTooltip(item, message, type = 'error') {
    const tooltip = item.querySelector('.stock-validation-tooltip');
    if (tooltip) {
      tooltip.textContent = message;
      tooltip.className = `stock-validation-tooltip ${type}`;
      tooltip.classList.remove('hidden');
      
      setTimeout(() => {
        hideStockTooltip(item);
      }, 3000);
    }
  }

  function hideStockTooltip(item) {
    const tooltip = item.querySelector('.stock-validation-tooltip');
    if (tooltip) {
      tooltip.classList.add('hidden');
    }
  }

  function setItemEditingState(item, isEditing) {
    if (!item) return;

    item.classList.toggle('editing', isEditing);
    item.querySelectorAll('.remove-item').forEach(button => {
      button.hidden = isEditing;
      button.setAttribute('aria-hidden', isEditing ? 'true' : 'false');
      button.tabIndex = isEditing ? -1 : 0;
      if (isEditing) {
        button.style.setProperty('display', 'none', 'important');
      } else {
        button.style.removeProperty('display');
      }
    });
  }

  function closeAllEditorsExcept(exceptItem = null) {
    document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal.editing').forEach(item => {
      if (item !== exceptItem) {
        const input = item.querySelector('.quantity-input');
        if (input && input.dataset.originalValue) {
          input.value = input.dataset.originalValue;
        }
        
        setItemEditingState(item, false);
        
        hideStockTooltip(item);
      }
    });
  }

  function initializeQuantityControls() {
    document.querySelectorAll('#cart-drawer-decimal .quantity-input').forEach(input => {
      if (input.value && input.value.includes(',')) {
        const americanValue = input.value.replace(',', '.');
        input.value = americanValue;
        if (!input.dataset.originalValue) {
          input.dataset.originalValue = americanValue;
        }
      }
    });
    
    document.querySelectorAll('#cart-drawer-decimal .quantity-edit-button').forEach(button => {
      if (button.hasEditListener) return;
      button.hasEditListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const cartItem = this.closest('.cart-item-decimal');
        const quantityEditControls = cartItem.querySelector('.quantity-edit-controls');
        
        if (!cartItem || !quantityEditControls) {
          return;
        }
        
        closeAllEditorsExcept(cartItem);
        
        setItemEditingState(cartItem, true);
        
        const input = cartItem.querySelector('.quantity-input');
        if (input) {
          const currentValue = parseFloat(input.value.replace(',', '.')) || 0.5;
          input.value = currentValue.toFixed(1).replace('.', ',');
          input.focus();
          input.select();
          
          // Add visual feedback when input value changes
          function addVisualFeedback() {
            input.classList.add('quantity-changed');
            
            // Escurecer o botão de confirmar quando o input muda
            const confirmBtn = cartItem.querySelector('.quantity-confirm');
            if (confirmBtn) {
              confirmBtn.classList.add('value-changed');
            }
            
            setTimeout(() => {
              input.classList.remove('quantity-changed');
            }, 300);
          }
          
          // Listen for manual input changes
          input.addEventListener('input', addVisualFeedback);
          
          // Listen for programmatic changes (from buttons)
          input.addEventListener('change', addVisualFeedback);
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-button').forEach(button => {
      if (button.hasQuantityListener) return;
      button.hasQuantityListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (this.classList.contains('plus') || this.classList.contains('minus')) {
          const input = this.parentNode.querySelector('.quantity-input');
          if (input) {
            let currentValue = parseDecimalBR(input.value);
            const step = this.classList.contains('plus') ? 0.1 : -0.1;
            const newValue = Math.max(0.1, currentValue + step);
            
            input.value = newValue.toFixed(1).replace('.', ',');
            
            // Add visual feedback directly
            input.classList.add('quantity-changed');
            
            // Escurecer o botão de confirmar quando o input muda
            const cartItem = input.closest('.cart-item-decimal');
            const confirmBtn = cartItem?.querySelector('.quantity-confirm');
            if (confirmBtn) {
              confirmBtn.classList.add('value-changed');
            }
            
            setTimeout(() => {
              input.classList.remove('quantity-changed');
            }, 300);
          }
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-confirm').forEach(button => {
      if (button.hasConfirmListener) return;
      button.hasConfirmListener = true;
      
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        if (isUpdating) {
          return;
        }

        const item = this.closest('.cart-item-decimal');
        const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
        const input = controls.querySelector('.quantity-input');
        const newValue = parseDecimalBR(input.value);

        if (newValue < 0.5) {
          showStockTooltip(item, 'Quantidade mínima: 0,5m', 'error');
          return;
        }

        const currentDecimal = parseFloat(item.dataset.decimalQuantity);
        const currentReal = parseInt(item.dataset.realQuantity);
        let decimalQuantity = newValue;
        let realQuantity = currentReal;

        if (!validateStock(item, decimalQuantity, realQuantity)) {
          return;
        }

        setDrawerProcessing(true);
        
        // Add visual feedback to confirm button
        const confirmBtn = this;
        const originalBg = confirmBtn.style.backgroundColor;
        confirmBtn.style.backgroundColor = '#15803d';
        confirmBtn.style.transform = 'scale(0.95)';
        
        setTimeout(() => {
          confirmBtn.style.backgroundColor = originalBg;
          confirmBtn.style.transform = '';
        }, 150);

        try {
          input.value = formatDecimalBR(decimalQuantity);

          const pricePerMeter = parseFloat(item.dataset.pricePerMeter || '0');
          const lineTotal = pricePerMeter * decimalQuantity * realQuantity;
          const priceElement = item.querySelector('.cart-item-price');
          if (priceElement) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              priceElement.textContent = Shopify.formatMoney(Math.round(lineTotal * 100));
            } else {
              priceElement.textContent = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(lineTotal);
            }
          }

          // Chamando updateSubtotalFromCart() - com descontos
          updateSubtotalFromCart();

          setItemEditingState(item, false);
          
          // Remover a classe value-changed do botão de confirmar
          const confirmBtn = item.querySelector('.quantity-confirm');
          if (confirmBtn) {
            confirmBtn.classList.remove('value-changed');
          }
        } catch (uiErr) {
        }

        const key = item.dataset.key;
        
        // Adicionar spinner no botão de confirmação
        const confirmBtnSpinner = item.querySelector('.quantity-confirm');
        if (confirmBtnSpinner) {
          // Adicionar spinner dentro do botão
          const spinner = document.createElement('div');
          spinner.className = 'quantity-loading-spinner';
          spinner.style.marginLeft = '8px';
          confirmBtnSpinner.appendChild(spinner);
          confirmBtnSpinner.disabled = true;
        }
        
        showLoading();
        
        const success = await updateCartQuantity(key, decimalQuantity, realQuantity);

        // Restaurar botão de confirmação
        if (confirmBtnSpinner) {
          const spinner = confirmBtnSpinner.querySelector('.quantity-loading-spinner');
          if (spinner) {
            spinner.remove();
          }
          confirmBtnSpinner.disabled = false;
        }

        if (success) {
          // Atualizar valor mínimo e desconto após sucesso na atualização do carrinho
          setTimeout(async () => {
            try {
              const cartData = await getCartData();
              if (cartData) {
                updateMinimumOrderDisplay(cartData);
                updateDiscountDisplay(cartData);
              }
            } catch (e) {
              console.error('Erro ao atualizar valor mínimo:', e);
            }
          }, 100);
        } else {
          const err = window.cartDrawerDecimalLastError || {};
          try {
            const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
            const inputRestore = controls?.querySelector('.quantity-input');
            if (inputRestore && inputRestore.dataset.originalValue) {
              inputRestore.value = inputRestore.dataset.originalValue;
            }
            setItemEditingState(item, true);
            if (!shouldSuppressUpdateErrorMessage(err)) {
              err.body = getUserFacingErrorMessage(err);
              showStockTooltip(item, err?.body || 'Não foi possível atualizar. Tente novamente.', 'error');
            }
          } catch (_e) {
          }
        }

        setDrawerProcessing(false);
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-input').forEach((inputEl) => {
      if (inputEl.hasKeyboardListener) return;
      inputEl.hasKeyboardListener = true;

      inputEl.addEventListener('keydown', (event) => {
        const item = inputEl.closest('.cart-item-decimal');
        if (!item) return;
        if (event.key === 'Enter') {
          event.preventDefault();
          const confirmBtn = item.querySelector('.quantity-confirm');
          confirmBtn?.click();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          const cancelBtn = item.querySelector('.quantity-cancel');
          cancelBtn?.click();
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-cancel').forEach(button => {
      if (button.hasCancelListener) return;
      button.hasCancelListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const item = this.closest('.cart-item-decimal');
        const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
        const input = controls.querySelector('.quantity-input');
        
        if (input && input.dataset.originalValue) {
          input.value = input.dataset.originalValue;
        }
        
        if (item) {
          setItemEditingState(item, false);
          
          // Remover a classe value-changed do botão de confirmar
          const confirmBtn = item.querySelector('.quantity-confirm');
          if (confirmBtn) {
            confirmBtn.classList.remove('value-changed');
          }
        }
        
        hideStockTooltip(item);
      });
    });
  }

  function initializeDrawerEvents() {
    const drawer = document.getElementById('cart-drawer-decimal');
    const drawerContentInit = drawer?.querySelector('.cart-drawer-content');
    
    if (drawer && drawerContentInit) {
      const cartItems = drawerContentInit.querySelectorAll('.cart-item-decimal');
      const cartEmptyDiv = drawerContentInit.querySelector('.cart-empty');
      const isEmpty = cartItems.length === 0 || !!cartEmptyDiv;
      
      if (isEmpty && !drawer.classList.contains('cart-empty')) {
        drawer.classList.add('cart-empty');
      } else if (!isEmpty && drawer.classList.contains('cart-empty')) {
        drawer.classList.remove('cart-empty');
      }
    }
    
    document.querySelectorAll('#cart-drawer-decimal [data-listener-initialized]').forEach(el => {
      el.removeAttribute('data-listener-initialized');
    });
    document.querySelectorAll('#cart-drawer-decimal [hasEditListener]').forEach(el => {
      el.hasEditListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasQuantityListener]').forEach(el => {
      el.hasQuantityListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasConfirmListener]').forEach(el => {
      el.hasConfirmListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasCancelListener]').forEach(el => {
      el.hasCancelListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasRemoveListener]').forEach(el => {
      el.hasRemoveListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasKeyboardListener]').forEach(el => {
      el.hasKeyboardListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasCheckoutListener]').forEach(el => {
      el.hasCheckoutListener = false;
    });
    
    const closeButton = document.getElementById('close-cart-drawer-decimal');
    if (closeButton && !closeButton.dataset.listenerInitialized) {
      closeButton.dataset.listenerInitialized = 'true';
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeCartDrawer();
      });
    }

    const continueButtons = document.querySelectorAll('#cart-drawer-decimal .continue-shopping, #cart-drawer-decimal .btn-continue-shopping, #cart-drawer-decimal [href=""], #cart-drawer-decimal [href="#"]');
    continueButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    const overlay = document.querySelector('#cart-drawer-decimal .drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeCartDrawer();
        }
      });
    }

    const drawerContentClick = document.querySelector('#cart-drawer-decimal .cart-drawer-content');
    if (drawerContentClick) {
      drawerContentClick.addEventListener('click', function(e) {
        const clickedInEditor = e.target.closest('.cart-item-decimal.editing .quantity-edit-controls');
        const clickedEditButton = e.target.closest('.quantity-edit-button');
        const clickedQuantityButton = e.target.closest('.quantity-button');
        const clickedQuantityInput = e.target.closest('.quantity-input');
        const clickedInEditingItem = e.target.closest('.cart-item-decimal.editing');
        
        if (!clickedInEditor && !clickedEditButton && !clickedQuantityButton && !clickedQuantityInput && !clickedInEditingItem) {
          const activeEditors = document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal.editing');
          if (activeEditors.length > 0) {
            closeAllEditorsExcept();
          }
        }
      });
    }

    const removeButtons = document.querySelectorAll('#cart-drawer-decimal .remove-item');
    removeButtons.forEach((button, index) => {
      if (!button.dataset.listenerInitialized) {
        button.dataset.listenerInitialized = 'true';
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          const key = this.dataset.key;
          
          if (key) {
            const success = await removeCartItem(key);
            if (success) {
              // Atualizar desconto após remover item
              setTimeout(async () => {
                try {
                  const cartData = await getCartData();
                  if (cartData) {
                    updateDiscountDisplay(cartData);
                  }
                } catch (e) {
                  console.error('Erro ao atualizar desconto após remoção:', e);
                }
              }, 100);
            }
          }
        });
      }
    });

    initializeQuantityControls();
    
    const checkoutButton = document.querySelector('#cart-drawer-decimal .checkout-button');
    if (checkoutButton && !checkoutButton.hasCheckoutListener) {
      checkoutButton.hasCheckoutListener = true;
      checkoutButton.addEventListener('click', function(e) {
        const spinner = this.querySelector('.spinner-container');
        if (spinner) {
          spinner.classList.add('show');
        }
        this.style.pointerEvents = 'none';
        this.disabled = true;
        
        // O spinner será removido quando a página redirecionar para o checkout
        // ou se houver erro, será removido pelo evento de erro
        window.addEventListener('beforeunload', function() {
          if (spinner) spinner.classList.remove('show');
        });
      });
    }

    document.querySelectorAll('#cart-drawer-decimal .js-close-drawer').forEach(btn => {
      if (btn._closeHandlerAttached) return;
      btn._closeHandlerAttached = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        closeCartDrawer();
      });
    });

    (async () => {
      try {
        const container = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
        if (!container) return;

        const productId = container.getAttribute('data-product-id');
        const limit = container.getAttribute('data-limit') || '10';
        const preferredIntent = container.getAttribute('data-intent') || 'complementary';
        const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.product_recommendations_url) || '/recommendations/products';
        const wrapper = container.querySelector('.swiper-wrapper');
        if (!productId || !wrapper) return;

        async function fetchHtml(url) {
          const res = await fetch(url);
          if (!res.ok) return null;
          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          return tmp;
        }

        async function tryHtmlVariants(intent) {
          let tmp = await fetchHtml(`${baseUrl}?product_id=${productId}&limit=${limit}&intent=${intent}`);
          if (tmp) {
            let slides = tmp.querySelectorAll('.product-recommendations .swiper-slide, [data-products-carousel] .swiper-slide');
            if (slides && slides.length) return Array.from(slides);
          }
          tmp = await fetchHtml(`${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${limit}&intent=${intent}`);
          if (tmp) {
            let slides = tmp.querySelectorAll('.product-recommendations .swiper-slide, [data-products-carousel] .swiper-slide');
            if (slides && slides.length) return Array.from(slides);
          }
          return null;
        }

        async function tryJson(intent) {
          try {
            const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`);
            if (!res.ok) return null;
            const data = await res.json();
            const products = data && (data.products || data);
            if (!products || !products.length) return null;
            return products.map(p => {
              const slide = document.createElement('div');
              slide.className = 'swiper-slide';
              const a = document.createElement('a');
              a.href = p.url || p.handle ? `/${p.handle}` : '#';
              a.className = 'card-product-cart';
              a.innerHTML = `
                <div class="card-product-cart-image">
                  <img src="${(p.featured_image && (p.featured_image.url || p.featured_image)) || ''}" alt="${(p.title || '').replace(/"/g,'&quot;')}">
                </div>
                <div class="card-product-cart-info">
                  <div class="card-product-cart-name"><h3>${p.title || ''}</h3></div>
                </div>`;
              slide.appendChild(a);
              return slide;
            });
          } catch (_e) { return null; }
        }

        let slides = await tryHtmlVariants(preferredIntent);
        if ((!slides || !slides.length) && preferredIntent !== 'related') {
          slides = await tryHtmlVariants('related');
        }
        if ((!slides || !slides.length)) {
          slides = await tryJson(preferredIntent) || await tryJson('related');
        }

        if (slides && slides.length) {
          wrapper.innerHTML = '';
          slides.forEach(slide => wrapper.appendChild(slide));
          setTimeout(() => initCartDrawerCarousel && initCartDrawerCarousel(), 0);
        } else {
          container.style.display = 'none';
        }
      } catch (e) {
      }
    })();
    
    setTimeout(() => {
      try {
        hasDrawerRecommendationsInitialized = false;
        populateDrawerRecommendations();
        initCartDrawerCarousel();
      } catch (e) {
      }
    }, 100);
  }

  document.addEventListener('cartItemAdded', function(e) {
    const productId = e.detail?.productId;
    if (productId) {
      const existingData = getProductDataFromStorage(productId);
      
      if (!existingData) {
        if (window.currentProductData) {
          saveProductData(window.currentProductData);
        }
        
        const genericData = localStorage.getItem('unidentified_product');
        if (genericData) {
          try {
            const parsedData = JSON.parse(genericData);
            
            const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
            
            saveProductData({
              ...parsedData,
              productId: cleanProductId,
              id: cleanProductId
            });
          } catch (e) {
          }
        }
      }
    }
    
    // Não abrir o drawer se estivermos no template cart
    if (isCartTemplate()) {
      return;
    }
    
    openCartDrawer();
    
    setTimeout(() => {
      try {
        refreshCartData().then(async () => {
          setTimeout(() => {
            persistCartKeyProductMapFromDOM();
          }, 100);
          
          try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (_e) {}
          try { await updateSubtotalFromCart(); } catch (_) {}
          try { await updateHeaderCartCountFromCart(); } catch (_) {}
          
          // Update discount display after adding products
          try {
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              updateDiscountDisplay(cartData);
            }
          } catch (_) {}
        }).catch(() => {
          try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (_e) {}
          try { updateSubtotalFromCart(); } catch (_) {}
          try { updateHeaderCartCountFromCart(); } catch (_) {}
        });
      } catch (_e) {
        try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (__e) {}
      }
    }, 50);
  });

  document.addEventListener('click', function(e) {
    if (e.target.matches('#open-cart-drawer-decimal') || e.target.closest('#open-cart-drawer-decimal')) {
      e.preventDefault();
      // Não abrir o drawer se estivermos no template cart
      if (isCartTemplate()) {
        return;
      }
      openCartDrawer();
      return;
    }
    
    if (e.target.matches('[data-toggle-cart]') || e.target.closest('[data-toggle-cart]')) {
      e.preventDefault();
      e.stopPropagation();
      
      // Não abrir o drawer se estivermos no template cart
      if (isCartTemplate()) {
        return;
      }
      
      setTimeout(() => {
        openCartDrawer();
      }, 10);
      return;
    }
    
    if (e.target.matches('#close-cart-drawer-decimal') || e.target.closest('#close-cart-drawer-decimal')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    
    if (e.target.matches('.continue-shopping, .btn-continue-shopping, [href=""], [href="#"]') || e.target.closest('.continue-shopping, .btn-continue-shopping, [href=""], [href="#"]')) {
      if (e.target.closest('#cart-drawer-decimal')) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
    }
    
    if (e.target.matches('#cart-drawer-decimal .remove-item') || e.target.closest('#cart-drawer-decimal .remove-item')) {
      e.preventDefault();
      e.stopPropagation();
      const button = e.target.matches('.remove-item') ? e.target : e.target.closest('.remove-item');
      const key = button?.dataset?.key;
      
      if (key) {
        setTimeout(async () => {
          const success = await removeCartItem(key);
          if (success) {
            // Atualizar desconto após remover item
            setTimeout(async () => {
              try {
                const cartData = await getCartData();
                if (cartData) {
                  updateDiscountDisplay(cartData);
                }
              } catch (e) {
                console.error('Erro ao atualizar desconto após remoção:', e);
              }
            }, 100);
          }
        }, 10);
      }
      return;
    }
    
    if (e.target.matches('#cart-drawer-decimal .drawer-overlay')) {
      closeCartDrawer();
      return;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      try {
        initializeDrawerEvents();
        updateSubtotalFromCart();
        updateHeaderCartCountFromCart();
      } catch (error) {
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
  } else {
    setTimeout(() => {
      try {
        initializeDrawerEvents();
        updateSubtotalFromCart();
        updateHeaderCartCountFromCart();
      } catch (error) {
      }
    }, 50);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isDrawerOpen) {
      closeCartDrawer();
    }
  });

  // Coupon feedback functions
  function showCouponSuccess(message) {
    clearCouponMessages();
    
    const successElement = document.createElement('div');
    successElement.className = 'coupon-message coupon-success';
    successElement.textContent = message;
    
    const appliedCoupon = document.getElementById('cart-drawer-applied-coupon');
    const couponWrapper = document.querySelector('.cart-drawer-footer .cart-decimal-coupon');
    
    if (appliedCoupon && appliedCoupon.style.display !== 'none') {
      appliedCoupon.insertAdjacentElement('afterend', successElement);
    } else if (couponWrapper) {
      couponWrapper.insertAdjacentElement('beforebegin', successElement);
    }
    
    setTimeout(() => {
      if (successElement) {
        successElement.remove();
      }
    }, 3000);
  }

  function showCouponError(message) {
    clearCouponMessages();
    
    const errorElement = document.createElement('div');
    errorElement.className = 'coupon-message coupon-error';
    errorElement.textContent = message;
    
    const appliedCoupon = document.getElementById('cart-drawer-applied-coupon');
    const couponWrapper = document.querySelector('.cart-drawer-footer .cart-decimal-coupon');
    
    if (appliedCoupon && appliedCoupon.style.display !== 'none') {
      appliedCoupon.insertAdjacentElement('afterend', errorElement);
    } else if (couponWrapper) {
      couponWrapper.insertAdjacentElement('beforebegin', errorElement);
    }
    
    // Remove error message after 5 seconds
    setTimeout(() => {
      if (errorElement && errorElement.parentNode) {
        errorElement.remove();
      }
    }, 5000);
  }

  function clearCouponMessages() {
    const errorElement = document.querySelector('.coupon-error');
    if (errorElement) {
      errorElement.remove();
    }
    
    const successElement = document.querySelector('.coupon-success');
    if (successElement) {
      successElement.remove();
    }
    
    const messageElements = document.querySelectorAll('.coupon-message');
    messageElements.forEach(element => element.remove());
  }

  // Coupon functionality for cart drawer
  function initializeCouponFunctionality() {
    const couponInput = document.getElementById('cart-drawer-coupon-input');
    const couponButton = document.getElementById('cart-drawer-coupon-button');
    const appliedCouponDiv = document.getElementById('cart-drawer-applied-coupon');
    const appliedCouponCode = document.getElementById('cart-drawer-applied-coupon-code');
    const removeCouponBtn = document.getElementById('cart-drawer-remove-coupon-btn');
    const discountDiv = document.getElementById('cart-drawer-discount');
    const discountValue = document.getElementById('cart-drawer-discount-value');

    if (!couponInput || !couponButton) return;

          // Check for existing coupon on page load
          function checkExistingCoupon() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Check if there's a price change (indicating existing discount)
                const hasPriceChange = cart.original_total_price && cart.total_price && 
                                     cart.total_price < cart.original_total_price;
                
                if (hasPriceChange) {
                  // Try to get coupon code from localStorage first
                  const storedCoupon = localStorage.getItem('lastAppliedCoupon');
                  if (storedCoupon) {
                    const couponInput = document.getElementById('cart-drawer-coupon-input');
                    if (couponInput) {
                      couponInput.dataset.lastAppliedCoupon = storedCoupon;
                    }
                  }
                }
                
                // Update discount display and subtotal
                updateDiscountDisplay(cart);
              })
              .catch(error => {
                console.error('Error checking existing coupon:', error);
              });
          }

    // Check for existing coupon when the function initializes
    checkExistingCoupon();

    // Apply coupon
    function applyCoupon() {
      const couponCode = couponInput.value.trim();
      if (!couponCode) return;

      // Show loading state
      couponButton.disabled = true;
      const couponText = document.getElementById('cart-drawer-coupon-text');
      const couponSpinner = document.getElementById('cart-drawer-coupon-spinner');
      
      if (couponText) couponText.style.display = 'none';
      if (couponSpinner) couponSpinner.style.display = 'flex';

      // Apply coupon via Shopify API
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: couponCode
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        
        // Verificar se há erros na resposta primeiro
        if (data.errors && data.errors.discount) {
          showCouponError(data.errors.discount[0] || 'Cupom inválido ou expirado');
          return;
        }
        
        // Verificar se há descontos aplicados (carrinho ou produto)
        const hasCartLevelDiscounts = data.cart_level_discount_applications && 
                           data.cart_level_discount_applications.length > 0;
        
        const hasItemLevelDiscounts = data.item_level_discount_applications && 
                                     data.item_level_discount_applications.length > 0;
        
        // Verificar se o preço mudou (indicando desconto aplicado)
        const hasPriceChange = data.original_total_price && data.total_price && 
                             data.total_price < data.original_total_price;
        
        const hasAnyDiscount = hasCartLevelDiscounts || hasItemLevelDiscounts || hasPriceChange;
        
        if (hasAnyDiscount) {
          // Save coupon code BEFORE clearing input
          const couponCode = couponInput.value.trim();
          couponInput.dataset.lastAppliedCoupon = couponCode;
          localStorage.setItem('lastAppliedCoupon', couponCode);
          
          // Cupom aplicado com sucesso
          showCouponSuccess('Cupom aplicado com sucesso!');
          
          // Update discount display and subtotal
          updateDiscountDisplay(data);
          
          // Clear input AFTER saving
          couponInput.value = '';
        } else {
          // Verificar novamente após um pequeno delay para dar tempo da API processar
          setTimeout(() => {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cartData => {
                
                // Verificar se há descontos aplicados (carrinho ou produto)
                const hasCartLevelDiscounts = cartData.cart_level_discount_applications && 
                                            cartData.cart_level_discount_applications.length > 0;
                
                const hasItemLevelDiscounts = cartData.item_level_discount_applications && 
                                            cartData.item_level_discount_applications.length > 0;
                
                // Verificar se o preço mudou (indicando desconto aplicado)
                const hasPriceChange = cartData.original_total_price && cartData.total_price && 
                                     cartData.total_price < cartData.original_total_price;
                
                const hasAnyDiscount = hasCartLevelDiscounts || hasItemLevelDiscounts || hasPriceChange;
                
                if (hasAnyDiscount) {
                  // Save coupon code BEFORE clearing input
                  const couponCode = couponInput.value.trim();
                  couponInput.dataset.lastAppliedCoupon = couponCode;
                  localStorage.setItem('lastAppliedCoupon', couponCode);
                  
                  // Cupom foi aplicado com sucesso após o delay
                  showCouponSuccess('Cupom aplicado com sucesso!');
                  
                  updateDiscountDisplay(cartData);
                  couponInput.value = '';
                } else {
                  // Cupom realmente inválido
                  showCouponError('Cupom inválido ou expirado');
                }
              })
              .catch(() => {
                showCouponError('Cupom inválido ou expirado');
              });
          }, 500);
        }
      })
      .catch(error => {
        console.error('Error applying coupon:', error);
        // Show error message
        showCouponError('Erro ao aplicar cupom. Tente novamente.');
      })
      .finally(() => {
        // Reset button state
        couponButton.disabled = false;
        if (couponText) couponText.style.display = 'flex';
        if (couponSpinner) couponSpinner.style.display = 'none';
        
        // Update subtotal once at the end
        updateSubtotalFromCart();
      });
    }

    // Remove coupon
    function removeCoupon() {
      // Show loading state
      const removeIcon = document.getElementById('cart-drawer-remove-icon');
      const removeSpinner = document.getElementById('cart-drawer-remove-spinner');
      
      if (removeIcon) removeIcon.style.display = 'none';
      if (removeSpinner) removeSpinner.style.display = 'flex';

      // Remove coupon from cart
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: ''
        })
      })
      .then(response => response.json())
      .then(data => {
        // Check if coupon was successfully removed
        if (!data.cart_level_discount_applications || data.cart_level_discount_applications.length === 0) {
          showCouponSuccess('Cupom removido com sucesso!');
        }
        
        // Update discount display and subtotal
        updateDiscountDisplay(data);
        
        // Update subtotal after removing coupon
        updateSubtotalFromCart();
      })
      .catch(error => {
        console.error('Error removing coupon:', error);
      })
      .finally(() => {
        // Reset button state
        if (removeIcon) removeIcon.style.display = 'flex';
        if (removeSpinner) removeSpinner.style.display = 'none';
      });
    }

    // Event listeners
    couponButton.addEventListener('click', applyCoupon);
    
    if (removeCouponBtn) {
      removeCouponBtn.addEventListener('click', removeCoupon);
    }
    
    couponInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        applyCoupon();
      }
    });
  }

  // Initialize coupon functionality when drawer events are initialized
  const originalInitializeDrawerEvents = initializeDrawerEvents;
  initializeDrawerEvents = function() {
    originalInitializeDrawerEvents();
    initializeCouponFunctionality();
  };

  window.cartDrawerDecimal = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: refreshCartData,
    updateDiscountDisplay: updateDiscountDisplay
  };
  
  window.cartDrawerDecimalInitialized = true;

} else {
}
